import {
  ADD_REVIEW_FORM_VALIDATION,
  FILTER_REVIEWS_BY_MEDIA_TYPE,
  HIDE_REVIEW_GALLERY_MODAL,
  NAVIGATE_TO_REVIEW,
  RECEIVE_PRODUCT_REVIEWS_WITH_MEDIA,
  REQUEST_PRODUCT_REVIEWS_WITH_MEDIA,
  RESET_ADD_REVIEW,
  SELECT_GALLERY_MEDIA,
  SET_DOC_META_PRODUCT_REVIEWS,
  SET_DOC_META_WRITE_REVIEW,
  SHOW_REVIEW_GALLERY_MODAL,
  SORT_MEDIA_REVIEWS,
  TOGGLE_SHOW_GALLERY,
  UPDATE_ADD_REVIEW_ABOUT,
  UPDATE_ADD_REVIEW_FIT,
  UPDATE_ADD_REVIEW_RATING,
  UPDATE_ADD_REVIEW_SUMMARY
} from 'constants/reduxActions';

import { productReviews } from 'apis/cloudcatalog';
import { fetchProductDetail, fetchProductReviews } from 'actions/productDetail';
import { IS_NUMBER_RE } from 'common/regex';
import { err, setError } from 'actions/errors';
import { fetchErrorMiddleware } from 'middleware/fetchErrorMiddleware';
import { trackError } from 'helpers/ErrorUtils';

export function showReviewGalleryModal(reviewId, reviewMediaIndex) {
  return {
    type: SHOW_REVIEW_GALLERY_MODAL,
    reviewId,
    reviewMediaIndex
  };
}

export function hideReviewGalleryModal() {
  return {
    type: HIDE_REVIEW_GALLERY_MODAL
  };
}

export function sortMediaReviews(orderBy) {
  return {
    type: SORT_MEDIA_REVIEWS,
    orderBy
  };
}

export function filterReviewsByMediaType(viewMediaType) {
  return {
    type: FILTER_REVIEWS_BY_MEDIA_TYPE,
    viewMediaType
  };
}

export function selectGalleryMedia(reviewMediaIndex) {
  return {
    type: SELECT_GALLERY_MEDIA,
    reviewMediaIndex
  };
}

export function navigateToReviewWithMedia(reviewId) {
  return {
    type: NAVIGATE_TO_REVIEW,
    reviewId
  };
}

export function toggleShowGallery() {
  return {
    type: TOGGLE_SHOW_GALLERY
  };
}

export function addFieldValidationErrors(errorMap) {
  return {
    type: ADD_REVIEW_FORM_VALIDATION,
    errorMap
  };
}

export function updateSummary(summary) {
  return {
    type: UPDATE_ADD_REVIEW_SUMMARY,
    summary
  };
}

export function updateRating({ name, value }) {
  return {
    type: UPDATE_ADD_REVIEW_RATING,
    rating: { name, value }
  };
}

export function updateFit({ name, value }) {
  return {
    type: UPDATE_ADD_REVIEW_FIT,
    fit: { name, value }
  };
}

export function updateAbout({ name, value }) {
  return {
    type: UPDATE_ADD_REVIEW_ABOUT,
    about: { name, value }
  };
}

export function resetAddReview() {
  return {
    type: RESET_ADD_REVIEW
  };
}

export function requestProductReviewsWithMedia() {
  return {
    type: REQUEST_PRODUCT_REVIEWS_WITH_MEDIA
  };
}

export function receiveProductReviewsWithMedia(reviews) {
  return {
    type: RECEIVE_PRODUCT_REVIEWS_WITH_MEDIA,
    reviews
  };
}

export function setWriteReviewDocMeta(product) {
  return { type: SET_DOC_META_WRITE_REVIEW, product };
}

export function setProductReviewsDocMeta(product) {
  return { type: SET_DOC_META_PRODUCT_REVIEWS, product };
}

export function loadProductReviewsPage(productId, reviewsPage, reviewsStart, orderBy) {
  return function(dispatch, getState) {
    return Promise.all([
      dispatch(fetchProductDetail(productId, { errorOnOos: false })),
      dispatch(fetchProductReviews(productId, reviewsPage, reviewsStart, true, orderBy)),
      dispatch(fetchProductReviewsWithMedia(productId))
    ])
      .then(() => {
        dispatch(setProductReviewsDocMeta(getState().product.detail));
      });
  };
}

export function loadWriteReviewPage() {
  const args = arguments;
  return function(dispatch, getState) {
    return dispatch(fetchProductDetail(...args))
      .then(() => {
        dispatch(setWriteReviewDocMeta(getState().product.detail));
      });
  };
}

export function fetchProductReviewsWithMedia(productId, isCrucial = false, limit) {
  return function (dispatch, getState) {
    dispatch(requestProductReviewsWithMedia());
    const state = getState();
    const { environmentConfig: { api: { cloudcatalog: cloudcatalogInfo } } } = state;
    return productReviews(cloudcatalogInfo, { productId, limit, filter: 'hasMedia:true' })
      .then(fetchErrorMiddleware)
      .then(({ reviews }) => {
        dispatch(receiveProductReviewsWithMedia(reviews));
      })
      .catch(e => {
        if (isCrucial) {
          dispatch(setError(err.PRODUCT_DETAILS, e));
        } else {
          trackError('NON-FATAL', 'Could not load Product Reviews.', e);
        }
      });
  };
}

export function fetchZenCustomerMedia(productId) {
  return (dispatch, getState) => {
    dispatch(requestProductReviewsWithMedia());
    const state = getState();
    const { environmentConfig: { api: { cloudcatalog: cloudcatalogInfo } } } = state;
    return productReviews(cloudcatalogInfo, { productId, types: 'zenMediaOnly' })
      .then(fetchErrorMiddleware)
      .then(({ reviews }) => {
        dispatch(receiveProductReviewsWithMedia(reviews));
      })
      .catch(e => {
        trackError('NON-FATAL', 'Could not load Zen customer media.', e);
      });
  };
}

export function isValidReviewsRequest({ productId, reviewsPage, reviewsStart }) { // dont bother validating orderBy since review fetcher handles any input
  return productId && IS_NUMBER_RE.test(productId) && (!reviewsPage || IS_NUMBER_RE.test(reviewsPage)) && (!reviewsStart || IS_NUMBER_RE.test(reviewsStart));
}
